<portal-context-switcher
  [dropdownItemTemplate]="dropdownItem"
  [entries]="trunks"
  [hideArrow]="true"
  [labelTemplate]="label"
  [placeholder]="'trunk.breadcrumbSwitcher.placeholder' | translate"
  (valueChanged)="switchRoute($event)"
  switchParameter="trunkId"
>
</portal-context-switcher>

<ng-template #dropdownItem let-entry="entry" let-term="term">
  <div class="trunk-switcher__dropdown-item">
    <span class="text-truncate" [innerHTML]="entry.label | highlightText: term"></span>
    @if (entry.meta.isTeamsTrunk) {
      <i class="teams-icon"></i>
    }
  </div>
</ng-template>

<ng-template #label>
  <div class="nav-item__context" role="button">
    <span class="text-truncate">{{ trunk.name }}</span>
    <i class="far fa-angle-down nav-item__context-icon"></i>
  </div>
</ng-template>
